<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Share',
  mounted() {
    let script = document.createElement('script');
    script.src = 'https://yastatic.net/es5-shims/0.0.2/es5-shims.min.js';
    document.body.appendChild(script);

    let script2 = document.createElement('script');
    script2.src = 'https://yastatic.net/share2/share.js';
    document.body.appendChild(script2);
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
    }),

    isShowedPopup() {
      return this.allShowedOverlays?.includes('share');
    },
  },

  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
    }),
    
    closePopup() {
      this.togglePopup('share');
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{ 'opacity-100 visible': isShowedPopup }"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between mb-2.5 md:mb-5">
          <img src="/public/images/logo.svg" alt="" class="w-full max-w-[186px] h-[41px] pr-2">
          <div
            class="popup-new__close"
            @click="closePopup"
          ></div>
        </div>
        
        <p class="title-h2 mb-6 !text-2xl pr-2">Поделиться авто в соцсетях</p>

        <div class="ya-share2 title_centered" data-services="vkontakte,facebook,twitter,odnoklassniki,viber,whatsapp,skype,telegram"></div>
      </div>
    </div>
  </div>
</template>